import { NgModule } from '@angular/core'
import { PageMetaLinkService, SeoMetaService } from '@spartacus/storefront'
import { EbPageMetaLinkService } from './eb-page-meta-link.service'
import { EbSeoMetaService } from './eb-seo-meta.service'

@NgModule({
  providers: [
    {
      provide: PageMetaLinkService,
      useClass: EbPageMetaLinkService
    },
    {
      provide: SeoMetaService,
      useClass: EbSeoMetaService
    }
  ]
})
export class EbSeoModule {}
